import { Component, ReactNode, ErrorInfo } from "react";
import * as Sentry from "@sentry/react";

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error("[ErrorBoundary] Caught error:", error);
    Sentry.captureException(error, {
      extra: { componentStack: errorInfo.componentStack },
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div className="flex h-screen items-center justify-center">
            <div className="text-center">
              <h1 className="text-2xl font-bold text-red-600">Neco se pokazilo</h1>
              <p className="mt-2 text-gray-600">Zkuste obnovit stranku.</p>
              <button
                onClick={() => window.location.reload()}
                className="mt-4 rounded bg-blue-500 px-4 py-2 text-white"
              >
                Obnovit
              </button>
            </div>
          </div>
        )
      );
    }
    return this.props.children;
  }
}
